<div class="fieldAttachmentModal" *transloco="let translate">
    <div class="d-flex  align-items-center mt-4" *ngIf="eventType === 'edit' || eventType === 'new'">
        <h4 class="matDialogTitle">Upload File :</h4>
        <span class="field-display-name relative top-[-3px] left-[10px] font-bold" [textContent]="field.displayName"></span>
    </div>
    <div class="mat-dialog-content mat-typography matDialogBody">
        <div>
            <div class="fieldAttachmentRow" [hidden]="inReadOnlyMode" *ngIf="eventType === 'edit' || eventType === 'new'">
                <span class="field-display-name" [textContent]="field.displayName + ' :'"></span>
                <span class="file-upload-item">
                    <app-file-upload [data]="fieldAttachmentData" [clearFiles]="clearFiles" (newValue)="onNewValue($event)" (fileName)="fileName = $event" [supportedFormats]="field.attachment && field.attachment.supportedTypes" (isFileTypeSupported)="onFileTypeSupportCheck($event)" [isDisabled]="maxFileCountReached"></app-file-upload>
                </span>
                <span class="upload-btn" *transloco="let translate">
                    <material-button [classList]="['!w-auto']" [disabled]="!files || files.length === 0 || !isFileTypeSupported || !isMaxFileSizeAllowed || maxFileCountReached" [color]="'primary'" [text]="translate('Upload')" (buttonClicked)="startUpload()"></material-button>
                </span>
            </div>
            <div [hidden]="inReadOnlyMode" *ngIf="eventType === 'edit' || eventType === 'new'">
                <span [textContent]="translate('Maximum allowed files count') + ':'"></span><strong [textContent]="field.attachment && field.attachment.maxFilesCount"></strong><span class="alreadyReached" *ngIf="maxFileCountReached" [textContent]="' ' + translate('Reached')"></span>
            </div>
            <div class="fieldAttachedFileName my-3 ">
                <span class="col-xs-5 fileNameLabel font-sans font-bold" [textContent]="translate('File(s) Name') + ' :'"></span>
                <span class="col-xs-7 fileNameValue ml-2" [textContent]="fileName"></span>
                <div class="fieldAttachedFileName row" [hidden]="!inReadOnlyMode">
                    <span class="col-xs-5 fileNameLabel">
                        <span [textContent]="translate('Field Name') + ' :'"></span>
                    </span>
                    <span class="col-xs-7 fileNameValue" [title]="field.displayName">
                        <span [textContent]="field.displayName"></span>
                    </span>
                </div>
                <div class="fileTypeSupport" *ngIf="!isFileTypeSupported">
                    <span [textContent]="translate('Please select') + ' ' + (field.attachment && field.attachment.supportedTypes) + ' ' + translate('file format to upload')"></span>
                </div>
                <div class="fileTypeSupport maxFileSizeAllowed" *ngIf="!isMaxFileSizeAllowed">
                    <span [textContent]="' ' + translate('Please upload a file of size less than') + ' ' + (field.attachment && field.attachment.maxSize) + ' ' + translate('MB')"></span>
                </div>
                <div class="uploadedFilesListContainer pt-2 pb-3">
                    <table aria-describedby="uploaded file list" class="w-full border-collapse ">
                        <thead class="bg-[#f5f5f5] table-header header-row text-center text-sm !leading-7">
                            <tr>
                                <th *ngFor="let header of allColumns" scope="col" class="font-medium bg-[#f5f5f5] border text-center py-2  relative text-sm !leading-3" [textContent]="header"></th>
                                <th *ngIf="eventType === 'edit' || eventType === 'new'" scope="col" class="font-medium !leading-3 bg-[#f5f5f5] border text-center py-2 text-sm relative" [textContent]="translate('Actions')"></th>
                            </tr>
                        </thead>
                        <tbody>
                            <ng-container *ngIf="tableData | async as data">
                                <ng-container *ngIf="data.length > 0; else noRecords">
                                    <tr *ngFor="let item of data; index as i" class="border !leading-3 text-center">
                                        <td class="border  text-sm !leading-3" [textContent]="item.fileName"></td>
                                        <td class="border  text-sm !leading-3">
                                            <a class="text-taxillaGreen cursor-pointer" [href]="item.url" [download]="item.fileName">Download</a>
                                        </td>
                                        <td *ngIf="eventType === 'edit' || eventType === 'new'" class="border  text-sm !line-height-4px">
                                            <ng-container *ngFor="let action of recordActions">
                                                <material-button
                                                                 [buttonType]="'icon'"
                                                                 (buttonClicked)="deleteFile(item, i)"
                                                                 [classList]="['!h-7', '!w-7']"
                                                                 [prefixIcon]="action.iconName"
                                                                 [prefixIconType]="'material'">
                                                </material-button>
                                            </ng-container>
                                        </td>
                                    </tr>
                                </ng-container>
                            </ng-container>
                            <ng-template #noRecords>
                                <tr *transloco="let translate" class="border text-center">
                                    <td colspan="3" class="py-1" [textContent]="translate('No records found')"></td>
                                </tr>
                            </ng-template>
                        </tbody>
                    </table>
                </div>

            </div>
        </div>
    </div>
